// MUI
import Box from '@mui/material/Box'
import Typography from '@mui/material/Typography'

// Style
import themeColors from 'assets/theme/colors'
import { getFontBody, getFontBodySmall, getFontH2 } from '@/assets/theme/fonts'

type Props = {
  eyebrow: string
  title: string
  /** Lead paragraphs shown under the title. */
  intro?: string[]
}

/**
 * The eyebrow / rule / title block that opens every section on this page.
 * Kept in one place so the sections stay consistent as the design evolves.
 */
export default function SectionHeader(props: Props) {
  return (
    <Box sx={{ marginBottom: '2.5rem' }}>
      <Typography
        sx={{
          fontSize: getFontBodySmall(),
          fontWeight: 700,
          letterSpacing: '0.08em',
          textTransform: 'uppercase',
          color: themeColors.success.main,
          marginBottom: '0.5rem'
        }}
      >
        {props.eyebrow}
      </Typography>

      <Box
        sx={{
          width: '2.5rem',
          borderTop: `3px solid ${themeColors.success.main}`,
          marginBottom: '1.25rem'
        }}
      />

      <Typography
        variant="h2"
        component="h2"
        fontSize={getFontH2()}
        sx={{
          fontWeight: 700,
          lineHeight: 1.2,
          color: themeColors.kroemtech.dunkelblau,
          marginBottom: props.intro?.length ? '1.25rem' : 0
        }}
      >
        {props.title}
      </Typography>

      {props.intro?.map(paragraph => (
        <Typography
          key={paragraph}
          sx={{
            fontSize: getFontBody(),
            lineHeight: 1.7,
            color: themeColors.gray.defaultText,
            maxWidth: '48rem',
            marginBottom: '0.85rem',
            '&:last-of-type': { marginBottom: 0 }
          }}
        >
          {paragraph}
        </Typography>
      ))}
    </Box>
  )
}
